import { Toaster as Sonner, type ToasterProps } from "sonner"

const Toaster = ({ ...props }: ToasterProps) => {


  return (
    <Sonner
      theme={'light' as ToasterProps["theme"]}
      closeButton
      className="tw-toaster tw-group"
      toastOptions={{
        classNames: {
          toast:
            "tw-group tw-toast group-[.toaster]:tw-bg-background group-[.toaster]:tw-text-foreground group-[.toaster]:tw-border-border group-[.toaster]:tw-shadow-lg",
          description: "group-[.toast]:tw-text-muted-foreground",
          actionButton: "group-[.toast]:tw-bg-primary group-[.toast]:tw-text-primary-foreground",
          cancelButton: "group-[.toast]:tw-bg-muted group-[.toast]:tw-text-muted-foreground",
          success: "group-[.toaster]:tw-border-l-success group-[.toaster]:tw-border-l-4 !tw-text-success",
          error: "group-[.toaster]:tw-border-l-destructive group-[.toaster]:tw-border-l-4 !tw-text-destructive",
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
